export enum symbolAssetConfig {



    hv1_sym = "assets/symbol/static/hv_1.png",
    hv2_sym = "assets/symbol/static/hv_2.png",
    hv3_sym = "assets/symbol/static/hv_3.png",
    hv4_sym = "assets/symbol/static/hv_4.png",
    hv5_sym = "assets/symbol/static/hv_5.png",
    lv1_sym = "assets/symbol/static/lv_1.png",
    lv2_sym = "assets/symbol/static/lv_2.png",
    lv3_sym = "assets/symbol/static/lv_3.png",
    lv4_sym = "assets/symbol/static/lv_4.png",
    lv5_sym = "assets/symbol/static/lv_5.png",
    bonus_sym = "assets/symbol/static/bonus.png",
    wild1x_sym = "assets/symbol/static/wild_1x1.png",
    wild2x_sym = "assets/symbol/static/wild_2x1.png",
    wild3x_sym = "assets/symbol/static/wild_3x1.png",



    symbols_blast_anim = "assets/symbol/animation/symbol_hv_lv_wild.json",
    bonus_sym_anim = "assets/symbol/animation/symbol_06.json",
    wild_sym_anim = "assets/symbol/animation/Wild 02.json",

}